import { Info } from '../model/shared/transaction/info';
import { BaseResponse } from './internal/baseresponse';
export class TransactionCancelResult extends BaseResponse {
  data: Info;
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncancelresult.ts